(() => {
  const SELECTOR = '[data-mbb-upcoming]';

  class MbbUpcoming {
    constructor(section) {
      this.section = section;

      this.viewport = section.querySelector('[data-upcoming-viewport]');
      this.track = section.querySelector('[data-upcoming-track]');
      this.slides = [...section.querySelectorAll('[data-upcoming-slide]')];

      this.prev = section.querySelector('[data-upcoming-prev]');
      this.next = section.querySelector('[data-upcoming-next]');
      this.pagination = section.querySelector('[data-upcoming-pagination]');
      this.navigation = section.querySelector('.mbb-upcoming-destinations__navigation');

      this.popup = section.querySelector('[data-upcoming-popup]');
      this.openButtons = [...section.querySelectorAll('[data-upcoming-popup-open]')];
      this.closeButtons = [...section.querySelectorAll('[data-upcoming-popup-close]')];

      if (!this.viewport || !this.track || !this.slides.length) return;

      this.index = 0;
      this.visible = 3;
      this.maxIndex = 0;

      this.startX = 0;
      this.deltaX = 0;
      this.dragging = false;

      this.resizeTimer = null;

      this.init();
    }

    init() {
      this.section.dataset.initialized = 'true';

      this.updateLayout();
      this.bindSlider();
      this.bindPopup();
    }

    visibleSlides() {
      if (window.innerWidth <= 749) return 1;
      if (window.innerWidth <= 990) return 2;
      return 3;
    }

    updateLayout() {
      this.visible = this.visibleSlides();
      this.maxIndex = Math.max(0, this.slides.length - this.visible);

      if (this.index > this.maxIndex) {
        this.index = this.maxIndex;
      }

      this.buildPagination();
      this.update();
    }

    slideWidth() {
      if (this.slides.length < 2) return this.slides[0].offsetWidth;

      return (
        this.slides[1].getBoundingClientRect().left -
        this.slides[0].getBoundingClientRect().left
      );
    }

    update() {
      this.track.style.transform =
        `translate3d(${-this.index * this.slideWidth()}px,0,0)`;

      this.prev?.toggleAttribute('disabled', this.index === 0);
      this.next?.toggleAttribute('disabled', this.index === this.maxIndex);

      if (this.navigation) {
        this.navigation.hidden = this.maxIndex === 0;
      }

      this.pagination?.querySelectorAll('button').forEach((dot, i) => {
        const active = i === this.index;

        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    go(index) {
      this.index = Math.max(0, Math.min(index, this.maxIndex));
      this.update();
    }

    buildPagination() {
      if (!this.pagination) return;

      this.pagination.innerHTML = '';

      for (let i = 0; i <= this.maxIndex; i++) {
        const button = document.createElement('button');

        button.type = 'button';
        button.setAttribute(
          'aria-label',
          `${this.pagination.dataset.paginationItemLabel} ${i + 1}`
        );

        button.addEventListener('click', () => this.go(i));

        this.pagination.appendChild(button);
      }
    }

    bindSlider() {
      this.prev?.addEventListener('click', () => this.go(this.index - 1));

      this.next?.addEventListener('click', () => this.go(this.index + 1));

      this.viewport.addEventListener('keydown', e => {

        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          this.go(this.index - 1);
        }

        if (e.key === 'ArrowRight') {
          e.preventDefault();
          this.go(this.index + 1);
        }

      });

      this.viewport.addEventListener('pointerdown', e => {
        this.dragging = true;
        this.startX = e.clientX;
        this.deltaX = 0;
        this.track.style.transition = 'none';
      });

      this.viewport.addEventListener('pointermove', e => {

        if (!this.dragging) return;

        this.deltaX = e.clientX - this.startX;

        this.track.style.transform =
          `translate3d(${
            -this.index * this.slideWidth() + this.deltaX
          }px,0,0)`;

      });

      const endDrag = () => {

        if (!this.dragging) return;

        this.dragging = false;

        this.track.style.transition =
          'transform .65s cubic-bezier(.22,1,.36,1)';

        if (Math.abs(this.deltaX) > 70) {
          this.go(this.index + (this.deltaX < 0 ? 1 : -1));
        } else {
          this.update();
        }

      };

      this.viewport.addEventListener('pointerup', endDrag);
      this.viewport.addEventListener('pointercancel', endDrag);

      window.addEventListener('resize', () => {

        clearTimeout(this.resizeTimer);

        this.resizeTimer = setTimeout(() => {
          this.updateLayout();
        }, 120);

      });

    }

        bindPopup() {
        if (!this.popup) return;

        const dialog = this.popup.querySelector('.mbb-upcoming-popup__dialog');
        const form = this.popup.querySelector('.mbb-upcoming-popup__form');
        const email = form?.querySelector('input[type="email"]');
        const submit = form?.querySelector('[data-upcoming-submit]');
        let lastFocused = null;

        const open = () => {
            lastFocused = document.activeElement;
            this.popup.hidden = false;

            requestAnimationFrame(() => {
            this.popup.setAttribute('aria-hidden', 'false');
            document.body.classList.add('mbb-popup-open');
            email?.focus();
            });
        };

        const close = () => {
            this.popup.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('mbb-popup-open');

            window.setTimeout(() => {
            this.popup.hidden = true;
            lastFocused?.focus?.();
            }, 300);
        };

        this.openButtons.forEach(button => {
            button.addEventListener('click', open);
        });

        this.closeButtons.forEach(button => {
            button.addEventListener('click', close);
        });

        form?.addEventListener('submit', event => {
            if (!form.checkValidity()) {
            event.preventDefault();
            form.reportValidity();
            return;
            }

            submit?.setAttribute('disabled', '');
            submit?.classList.add('is-loading');

            const label = submit?.querySelector('span');

            if (label) {
            label.dataset.originalText = label.textContent;
            label.textContent = 'INSCRIPTION…';
            }
        });

        this.popup.addEventListener('keydown', event => {
            if (event.key === 'Escape') close();

            if (event.key !== 'Tab' || !dialog) return;

            const focusable = [
            ...dialog.querySelectorAll(
                'button:not([disabled]),input:not([disabled]),a[href],[tabindex]:not([tabindex="-1"])'
            )
            ];

            if (!focusable.length) return;

            const first = focusable[0];
            const last = focusable[focusable.length - 1];

            if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
            }
        });

        const params = new URLSearchParams(window.location.search);
        const hasFeedback =
            params.get('newsletter') === 'success' ||
            this.popup.querySelector('[data-upcoming-success]') ||
            this.popup.querySelector('[data-upcoming-error]');

        if (hasFeedback) open();
        }

    destroy() {
      window.removeEventListener('resize', this.updateLayout);
    }

  }

  const init = root => {

    root.querySelectorAll(SELECTOR).forEach(section => {

      if (section.dataset.initialized === 'true') return;

      section.instance = new MbbUpcoming(section);

    });

  };

  const start = () => init(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', e => {
    init(e.target);
  });

})();
